import { useEffect, useState } from 'react';
import { Header, HeaderTitle } from '../styles';

import { notifyError, notifySuccess } from './utils';

import { CircularProgressIndicator } from '../../../components-reactjs/CircularProgressIndicator';
import ButtonLoading from '../../../react-component/buttonLoading';
import Modal from '../../../react-component/modal';

import {
    Paper,
    TableBody,
    TableHead,
    Table as TableMaterial,
    TableRow
} from '@mui/material';

import { Delete } from '@mui/icons-material';
import { addFaixaCep, deleteFaixaCep, getAllFaixasCep } from './services';
import {
    ButtonHeaderContainer,
    Container,
    ErrorContainer,
    ErrorText,
    Footer,
    PaginationContainer,
    StyledPagination,
    StyledTableCell,
    StyledTableContainer,
    StyledTableRow,
    Text,
    TextInputNative,
    UsuariosContainer
} from './styles';

const FaixasCeps = () => {
    const [form, setForm] = useState({
        dsFaixaCep: '',
        nrFaixaInicial: '',
        nrFaixaFinal: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [modalCadastroVisible, setModalCadastroVisible] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);

    const getTableData = () => {
        setIsLoading(true);
        getAllFaixasCep(page, 10)
            .then(({ data }) => {
                setTableData(data.faixas);
                setTotal(data.total);
            })
            .catch(() => {
                notifyError('Não foi possível buscar as faixas de CEP');
            })
            .finally(() => {
                setIsLoading(false);
                setIsInitialLoading(false);
            });
    };

    const saveFaixa = () => {
        const { dsFaixaCep, nrFaixaInicial, nrFaixaFinal } = form;

        if (!dsFaixaCep || !nrFaixaInicial || !nrFaixaFinal) {
            setErrorMessage('Todos os campos são obrigatórios');
            return;
        }

        if (nrFaixaInicial.length !== 8 || nrFaixaFinal.length !== 8) {
            setErrorMessage(
                'CEP Inicial e Final devem conter exatamente 8 dígitos'
            );
            return;
        }

        setIsLoading(true);
        addFaixaCep(form)
            .then(() => {
                notifySuccess('Faixa de CEP cadastrada com sucesso');
                setForm({
                    dsFaixaCep: '',
                    nrFaixaInicial: '',
                    nrFaixaFinal: ''
                });
                setModalCadastroVisible(false);
                getTableData();
            })
            .catch((err) => {
                const msg =
                    (err &&
                        err.response &&
                        err.response.data &&
                        err.response.data.errorMessage) ||
                    err.message ||
                    'Erro ao salvar faixa de CEP';

                notifyError(msg);
            })
            .finally(() => {
                setErrorMessage(null);
                setIsLoading(false);
            });
    };

    const handleDeleteFaixa = async (idFaixaCep) => {
        try {
            await deleteFaixaCep(idFaixaCep);
            notifySuccess('Faixa CEP excluída com sucesso');
            getTableData();
        } catch (res) {
            notifyError('Não foi possível excluir faixa CEP');
        }
    };

    useEffect(() => {
        getTableData();
    }, [page]);

    if (isInitialLoading) {
        return <CircularProgressIndicator />;
    }

    return (
        <UsuariosContainer>
            <Header>
                <HeaderTitle>Faixas de CEP</HeaderTitle>
                <ButtonHeaderContainer>
                    <ButtonLoading
                        label={<Text>Cadastrar</Text>}
                        onPress={() => setModalCadastroVisible(true)}
                        isLoading={false}
                        disabled={false}
                        style={{ marginTop: 0 }}
                    />
                </ButtonHeaderContainer>
            </Header>

            {modalCadastroVisible && (
                <Modal
                    title={<Text>Cadastrar faixa de CEP</Text>}
                    saveText={<Text>Cadastrar</Text>}
                    onSave={saveFaixa}
                    onClose={() => {
                        setModalCadastroVisible(false);
                        setErrorMessage(null);
                        setForm({
                            dsFaixaCep: '',
                            nrFaixaInicial: '',
                            nrFaixaFinal: ''
                        });
                    }}
                    isSaveButtonLoading={isLoading}
                >
                    <Text>Descrição</Text>
                    <TextInputNative
                        placeholder="Identificação da faixa de CEP (nome da rua, bairro, etc)"
                        value={form.dsFaixaCep}
                        onChange={(e) =>
                            setForm({ ...form, dsFaixaCep: e.target.value })
                        }
                    />
                    <Text style={{ marginTop: 10 }}>CEP Inicial</Text>
                    <TextInputNative
                        maxLength={8}
                        value={form.nrFaixaInicial}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                nrFaixaInicial: e.target.value.replace(
                                    /\D/g,
                                    ''
                                )
                            })
                        }
                    />
                    <Text style={{ marginTop: 10 }}>CEP Final</Text>
                    <TextInputNative
                        maxLength={8}
                        value={form.nrFaixaFinal}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                nrFaixaFinal: e.target.value.replace(/\D/g, '')
                            })
                        }
                    />
                    {errorMessage && (
                        <ErrorContainer>
                            <ErrorText>
                                <Text>{errorMessage}</Text>
                            </ErrorText>
                        </ErrorContainer>
                    )}
                </Modal>
            )}

            <Container>
                <StyledTableContainer component={Paper}>
                    <TableMaterial
                        aria-label="Tabela de faixas de CEP"
                        stickyHeader
                    >
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>
                                    <Text>Descrição</Text>
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Text>CEP Inicial</Text>
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Text>CEP Final</Text>
                                </StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.map((cep) => {
                                const descricao =
                                    cep.dsFaixaCep || 'Sem descrição';

                                return (
                                    <StyledTableRow key={cep.idLojaFaixaCep}>
                                        <StyledTableCell>
                                            <Text>{descricao}</Text>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Text>{cep.nrFaixaInicial}</Text>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Text>{cep.nrFaixaFinal}</Text>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <button
                                                onClick={() =>
                                                    handleDeleteFaixa(
                                                        cep.idLojaFaixaCep
                                                    )
                                                }
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <Delete
                                                    sx={{
                                                        fontSize: 24,
                                                        color: 'red'
                                                    }}
                                                />
                                            </button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                    </TableMaterial>
                </StyledTableContainer>

                <Footer>
                    <PaginationContainer>
                        <StyledPagination
                            count={Math.ceil(total / 10)}
                            color="primary"
                            size="medium"
                            onChange={(e, page) => setPage(page)}
                        />
                    </PaginationContainer>
                </Footer>
            </Container>
        </UsuariosContainer>
    );
};

export { FaixasCeps };
